// 🧩 Globaler Fallback für trapFocus und removeTrapFocus
if (typeof window.trapFocus !== "function") {
  window.trapFocus = function (container) {
    if (!container) return;
    const focusable = container.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusable) focusable.focus();
  };
  console.debug("[cart-drawer] trapFocus polyfill aktiv ✅");
}

if (typeof window.removeTrapFocus !== "function") {
  window.removeTrapFocus = function () {
    document.activeElement?.blur();
  };
  console.debug("[cart-drawer] removeTrapFocus polyfill aktiv ✅");
}

// 🧩 Shopify Focus Utilities (Fix)
function trapFocus(container, elementToFocus = container) {
  const focusableElements = container.querySelectorAll(
    'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [contenteditable], [tabindex]:not([tabindex^="-"])'
  );
  const first = focusableElements[0];
  const last = focusableElements[focusableElements.length - 1];

  container.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  elementToFocus.focus();
}

function removeTrapFocus(container) {
  container.removeEventListener('keydown', trapFocus);
}

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    // 🧩 Fix: Reagiere auf Mengenänderung im Drawer
    this.addEventListener('change', (e) => {
      if (e.target && e.target.name === 'updates[]') {
        this.handleQuantityChange(e);
      }
    });
  }
// 🧩 Fix: Mengenänderung und Löschen im CartDrawer
handleQuantityChange(event) {
  const input = event.target;
  if (!input || !input.dataset.index) return;

  const line = input.dataset.index;
  const value = parseInt(input.value);

  if (isNaN(value) || value < 0) {
    console.warn(`[CartDrawer] Ungültige Menge für Zeile ${line}`);
    return;
  }

  // 🧩 Shopify-kompatible Cart-API nutzen
  fetch(`${routes.cart_change_url}`, {
    ...fetchConfig(),
    body: JSON.stringify({
      line,
      quantity: value,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    }),
  })
    .then((res) => res.text())
    .then((state) => {
      const parsed = JSON.parse(state);

      // 🧩 Wenn Menge = 0 → Element direkt entfernen
      if (value === 0) {
        const item = input.closest('.cart-item');
        if (item) item.remove();
      }

      // 🧩 Inhalte neu rendern
      this.renderContents(parsed);
      console.debug('[CartDrawer] Menge aktualisiert ✅');
    })
    .catch((err) => console.error('[CartDrawer] Update-Fehler', err));
}



  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // Animation-Fix (Shopify Refresh Bug)
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
// 🧩 Fix: Mengenänderung & Entfernen im Drawer (auch nach AJAX-Neuladen)
function initCartDrawerHandlers() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  // --- Stückzahl ändern ---
  drawer.querySelectorAll('.quantity__button').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const input = btn.parentElement.querySelector('.quantity__input');
      const index = input.dataset.index;
      let value = parseInt(input.value);

      if (btn.name === 'plus') value++;
      if (btn.name === 'minus' && value > 0) value--;

      fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({
          line: index,
          quantity: value,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      })
        .then((res) => res.text())
        .then((state) => {
          const parsed = JSON.parse(state);
          drawer.renderContents(parsed);
          setTimeout(initCartDrawerHandlers, 100); // <– Reaktivieren nach Render
        })
        .catch((err) => console.error('[CartDrawer] Mengenänderung fehlgeschlagen', err));
    });
  });

  // --- Artikel löschen ---
  drawer.querySelectorAll('.cart-remove-button').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const line = btn.closest('[data-index]')?.dataset.index || btn.dataset.index;

      fetch(`${routes.cart_change_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({
          line,
          quantity: 0,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      })
        .then((res) => res.text())
        .then((state) => {
          const parsed = JSON.parse(state);
          drawer.renderContents(parsed);
          setTimeout(initCartDrawerHandlers, 100); // <– Reaktivieren nach Render
        })
        .catch((err) => console.error('[CartDrawer] Entfernen fehlgeschlagen', err));
    });
  });
}

// Initial aktivieren
document.addEventListener('DOMContentLoaded', initCartDrawerHandlers);
